
import { Component, Prop, Vue } from 'vue-property-decorator';
import { STAT, URLVER } from '@/config/config';
import { pushBy2804 } from '@/utils/tools';
@Component
export default class TabBar extends Vue {
  @Prop() private tabItems!: Array<object>;
  @Prop() private swiperIndex!: number;
  @Prop() private showMore!: Boolean;
  @Prop() private showClose!: Boolean;
  jumpMore() {
    window.hxmPageStat(`${STAT.follow}.wdgz`, URLVER);
    pushBy2804('/myFollow', null);
  }
  clickTab(item: object, index: number) {
    this.$emit('clickTab', item, index);
    if (
      window.sessionStorage.getItem('triangleLeft') &&
      //!: 非空断言
      Number(JSON.parse(window.sessionStorage.getItem('triangleLeft')!)[0]) === index
    ) {
      this.$emit('changeTriangle', JSON.parse(window.sessionStorage.getItem('triangleLeft')!)[1]);
    } else {
      this.$emit('changeTriangle', window.sessionStorage.getItem('triangleFirst'));
    }
  }
  closePop() {
    this.$emit('closePop');
  }
  changeTriangle() {
    this.$emit('closePop');
  }
}
